<template>
  <QuestionBase :id="db.saveField"
                :errors="[...jsErrors]"
                :question="question"

                :valid="!!data.length">
    <transition name="fade">
      <div class="accordion sub-items">
        <ObjectCard v-for="(liability, index) in data"
                    :id="'liability-credit-card'+index"
                    :key="'liability-credit-card' + liability.id"
                    :ref="'liability-credit-card'+index"
                    v-model="data[index]"
                    :title="`${liability.liabilityType} ${liability.liabilityLender ? liability.liabilityLender : ''}`"
                    type="liability-credit-card"
                    :loading="loading"
                    @delete="deleteObject(liability.id)"
                    @save="saveObject(liability, 'liability-credit-card'+index)">
          <Component :is="formType"
                     :key="'liability-form' + liability.id"
                     v-model="data[index]"
                     :objectId="liability.id" />
        </ObjectCard>

        <ObjectCard v-if="form"
                    ref="liability-credit-card-add"
                    v-model="form"
                    title="New Credit Card"
                    type="liability-credit-card-add"
                    :loading="loading"
                    @delete="form=null"
                    @save="saveObject(form, db.saveField)">
          <Component :is="formType"
                     v-model="form"
                     :errors-post="errorsPost"
                     :noSave="true" />
        </ObjectCard>

        <b-button v-if="!form"
                  class="btn-question w-100"
                  @click="add">
          <i class="i-Male-2 text-25 font-weight-800 mr-2"> </i> Add Credit Card
        </b-button>
      </div>
    </transition>
  </QuestionBase>
</template>
<script>
import {objectSaveHelpers} from "../../objects/objectSaveHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {blankForms} from "../../../helpers/blankForms";

import QuestionBase from "../../../QuestionBase";
import ObjectCard from "../../objects/ObjectCard";
import LiabilityCreditCardFull from "../../../../fieldsets/sub/liability/LiabilityCreditCardFull";
import LiabilityCreditCardMortgage from "../../../../fieldsets/sub/liability/mortgage/LiabilityCreditCardMortgage";
import LiabilityCreditCardEstatePlanning from "../../../../fieldsets/sub/liability/estatePlanning/LiabilityCreditCardEstatePlanning";

export default {
  name: 'LiabilitiesCreditCards',
  components: {
    LiabilityCreditCardFull,
    LiabilityCreditCardEstatePlanning,
    LiabilityCreditCardMortgage,
    ObjectCard,
    QuestionBase
  },
  mixins: [
    objectSaveHelpers,
    questionLoadHelpers,
    blankForms
  ],
  props: {
    value: {
      type: Array,
      required: false
    },
    type: {
      type: String,
      default: 'full'
    }
  },
  data() {
    return {
      question: {
        title: null,
        subTitle: null,
        tip: null,
      },
      db: {
        saveLocation: 'client_liability',
        saveField: 'liabilities_credit_cards',
        deleteLocation: 'client_liability',
        loadLocation: 'client_liabilities_credit_cards',
        syncMultipleObjectOnSave: true,
        fetchObjectsOnSave: false
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessageNewOpenForm: "Save credit card before proceeding, by clicking 'confirm'"
      },
      serverErrors: [],
      errorsPost: {},
      jsErrors: [],
      skipped: false,
      form: null,
      errors: {}
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    formType() {
      if (this.type === 'mortgage') return 'LiabilityCreditCardMortgage'
      if (this.type === 'estatePlanning') return 'LiabilityCreditCardEstatePlanning'
      return 'LiabilityCreditCardFull'
    }
  },
  methods: {
    add() {
      this.form = null
      this.form = Object.assign({},
          this.liabilityBlankForm)
      this.form.liabilityType = 'Credit Card'
    }
  }
}
</script>
